import {Component, OnDestroy, OnInit} from '@angular/core';
import { NzModalService } from 'ng-zorro-antd';
import { TextService } from '../../services/text.service';
import { SdkInitText } from '../../../model/user/sdk-init-text';
import { MessageService } from '../../services/message-service';
import { SessionService} from "../../services/session.service";
import { NetmeraService } from "../../../shared/services/netmera-service";
import { PaycellNedir } from "../../../model/netmera-events/paycell-nedir";
import {ActivatedRoute, Router} from "@angular/router";
import {UserDto} from "../../../model/user/user-dto";

@Component({
  selector: 'pa-what-is-paycell',
  templateUrl: './what-is-paycell.component.html',
  styleUrls: ['./what-is-paycell.component.scss']
})
export class WhatIsPaycellComponent implements OnInit, OnDestroy {

  textService: TextService;
  sdkInitTexts: Array<SdkInitText>;
  user: UserDto;
  trackingId: string;

  constructor(private modalService: NzModalService, textService: TextService, private messageService: MessageService, private route: ActivatedRoute,
              private router: Router, private sessionService :SessionService, private netmeraService: NetmeraService, private paycellNedir: PaycellNedir) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.sdkInitTexts = this.messageService.getSdkInitTexts();
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
      this.sessionService.getInitUser(this.trackingId).subscribe(response => {
        this.user = response;
      });
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

  ngOnDestroy(): void {
    this.netmeraService.pushEvent(this.paycellNedir.setEventObject("PaycellNedirKapatildi", this.user?.requestHeader?.merchant?.merchantCode ));
  }

  close() {
    this.modalService.closeAll();
  }

}
